import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, ButtonBase, Paper, Stack } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";

import { type Case, CaseStatus } from "../types";

interface Props {
  case: Case;
  onClick?: () => void;
  /** Renders a Reopen action on closed cases (mirrors desktop). */
  onReopen?: () => void;
}

export function MobileCaseCard({ case: caseItem, onClick, onReopen }: Props) {
  const { tu } = useTu("homeHealth");
  const { patient, status } = caseItem.attributes;
  const canReopen = status === CaseStatus.CLOSED && Boolean(onReopen);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "transparent",
        boxShadow: "0 1px 4px 0 rgba(0,0,0,0.25)",
        padding: "1rem",
      }}
    >
      {/* Info area is one tap target; the Reopen action below stays separate. */}
      <ButtonBase
        onClick={onClick}
        sx={{ width: "100%", textAlign: "left", borderRadius: 2, display: "block" }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Stack flex={1} spacing={0.75}>
            <Text variant="h5" data-dd-privacy="mask">
              {patient.attributes.externalPatientIdentifier}
            </Text>
            <Stack direction="row" alignItems="flex-start" spacing={0.5}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "1.5rem",
                  flexShrink: 0,
                }}
              >
                <LocationOnIcon sx={{ fontSize: 18, color: "text.secondary" }} />
              </Box>
              <Text variant="body1" data-dd-privacy="mask" sx={{ color: "text.secondary" }}>
                {patient.attributes.formattedAddress}
              </Text>
            </Stack>
          </Stack>
          <ChevronRightIcon sx={{ color: "text.secondary", flexShrink: 0 }} />
        </Stack>
      </ButtonBase>

      {canReopen && (
        <Button
          fullWidth
          variant="secondary"
          sx={{ marginTop: 3 }}
          onClick={() => {
            onReopen?.();
          }}
        >
          {tu("Reopen case")}
        </Button>
      )}
    </Paper>
  );
}
